module.exports = __webpack_public_path__ + "img/u1456.07835744.png";